import ButtonGroup from '../../molecules/buttonGroup/view';
import NewUser from '../../organisms/NewUser/view';
import UsersOperationsTable from '../../organisms/UsersOperationsTable/view';
import './style.css';

const OperationsPage = () => {
  return (
    <>
      <ButtonGroup
        title="Usuarios y Operaciones"
        description="Gestiona los accesos de tu equipo y supervisa sus movimientos."
      >
        <NewUser />
      </ButtonGroup>
      <div className='operations-page-container'>
        <UsersOperationsTable />
      </div>
    </>
  );
};

export default OperationsPage;
